import type { SVGProps } from 'react';
export const SvgFacebook = (props: SVGProps<SVGSVGElement>) => (
	<svg
		xmlns="http://www.w3.org/2000/svg"
		width={40}
		height={40}
		fill="none"
		viewBox="0 0 40 40"
		{...props}
	>
		<rect width={40} height={40} fill="#1877F2" rx={10} />
		<path
			fill="#fff"
			d="M27.785 25.781 28.672 20h-5.547v-3.75c0-1.582.773-3.125 3.258-3.125h2.523V8.203s-2.289-.39-4.476-.39c-4.57 0-7.555 2.769-7.555 7.78V20h-5.078v5.781h5.078v13.977q1.531.241 3.125.242 1.595-.001 3.125-.242V25.78z"
		/>
	</svg>
);
